import { createContext, useState, useContext } from "react"; // Правильний імпорт ReactNode
// Використовуємо import type для імпорту типів
import type { ReactNode } from "react"; // Використовуємо type-only import

interface PopupContextType {
  isOpenMenu: boolean;
  openMenu: () => void;
  closeMenu: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpenMenu, setIsOpen] = useState(false);

  const openMenu = () => setIsOpen(true);
  const closeMenu = () => setIsOpen(false);

  return (
    <PopupContext.Provider value={{ isOpenMenu, openMenu, closeMenu }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error("usePopup must be used within a PopupProvider");
  }
  return context;
};
